<template>
  <a-modal :title="title" :footer="null" v-model="visible" :maskClosable="false" @cancel="cancel" :class="isSuccess?'preview-print-success-model' :'preview-print-model'">
    <div class="success-image" v-if="isSuccess">
      <img src="@/assets/image/chenggong.png" alt="" class="image">
      <span class="success-text">您是否需要打印此单？</span>
    </div>
    <div class="preview-print-box">
      <a-row>
        <a-col>
          <a-button @click="btnPrint" :loading="iconLoading">{{ printText }}</a-button>
        </a-col>
        <a-col>
          <a-button @click="btnLookPrint">打印预览</a-button>
        </a-col>
      </a-row>
      <a-row>
        <a-col>
          <a-button @click="btnPrintPreview">自定义编辑</a-button>
        </a-col>
        <a-col>
          <a-button @click="cancel">退出</a-button>
        </a-col>
      </a-row>
    </div>
    <a-modal :title="''" :footer="null" v-model="printVisible" class="ptint-look-modal">
      <print-preview :templateType="templateType" :formData="formData"></print-preview>
    </a-modal>
    <div v-show="false">
      <vue-easy-print tableShow ref="easyPrint">
        <template slot-scope="func">
          <print-preview :getChineseNumber="func.getChineseNumber" :templateType="templateType" :formData="formData"></print-preview>
        </template>
      </vue-easy-print>
    </div>
  </a-modal>
</template>
<script>
import { printdata } from "./printdata";
import vueEasyPrint from "vue-easy-print"
import printPreview from './printPreview'
export default {
  mixins: [printdata],
  components: {
    vueEasyPrint,
    printPreview
  },
  data() {
    return {
      title: "数据打印",
      printText: "开始打印",
      visible: false,
      imgUrl: [],
      previewVisible: false,
      previewImage: '',
      templateType: null,
      startTime:null,
      endTime:null,
      total:null,
      formData:{},
      printVisible: false,
      orderId:null,
      isSuccess: false,
      iconLoading: false
    };
  },
  mounted() {

  },
  methods: {
    open(data) {
      let _that = this
      this.templateType = data.templateType
      if(data.total) {
        this.total = data.total
        this.endTime = data.endTime
        this.startTime = data.startTime
      }
      if(data.isSuccess) {
        this.orderId = data.id
        this.isSuccess = data.isSuccess
        this.title = '保存成功'
      } else {
        if(this.$route.query.voucherEntityId) {
          this.orderId = this.$route.query.voucherEntityId
        } else {
          this.orderId = this.$route.query.id
        }
      }
      this.getPrintList()
      setTimeout(function() {
        _that.visible = true
      }, 500)
      
      
    },
    cancel() {
      this.visible = false;
      this.$emit('cancelPrint')
    },
    btnPrintPreview() {
      this.visible = false;
      this.$emit('cancelPrint')
      setTimeout(() => {
          if(this.total) {
            this.$router.push({ path: "/printmanagement/printset/printPage?templateType="+this.templateType+"&total="+this.total+"&startTime="+this.startTime+"&endTime="+this.endTime });
          } else {
            if(this.isSuccess){
              this.$router.push({ path: "/printmanagement/printset/printPage?id="+this.orderId+'&templateType='+this.templateType });
            }else{
              if(this.$route.query.voucherEntityId) {
                this.$router.push({ path: "/printmanagement/printset/printPage?id="+this.$route.query.voucherEntityId+'&templateType='+this.templateType });
              } else {
                this.$router.push({ path: "/printmanagement/printset/printPage?id="+this.$route.query.id+'&templateType='+this.templateType });
              }
            }
          }
      }, 500);
    },
    // 打印预览
    btnLookPrint() {
       this.printVisible = true
    },
    // 打印数据
    btnPrint() {
      let _that = this
      _that.printText = "加载中..."
      _that.iconLoading = true
      setTimeout(function() {
        _that.iconLoading = false
        _that.printText = "开始打印"
        _that.$refs.easyPrint.print();
      }, 2000)
    }
  },
  watch: {
    visible() {
      if(!this.visible) {
        this.$emit('cancelPrint')
      }
    },
  },
};
</script>

<style lang="scss">
.ptint-look-modal {
  width: 1000px !important;
  height: 80%;
  .ant-modal-content {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  .ant-modal-body {
    width: 100%;
    height: 85%;
    overflow: auto;
    margin: 0 36px 20px 36px;
  }
}
.preview-print-model {
  width: 560px !important;
  height: 278px !important;
  .preview-print-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .ant-row {
      display: flex;
      .ant-col {
        padding: 0 10px 20px 10px;
      }
    }
  }
}
.preview-print-success-model {
  width: 560px !important;
  .ant-modal-body {
    padding-top: 0;
  }
  .success-image {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .image {
      width: 70px;
      height: 70px;
    }
    .success-text {
      padding: 32px 0;
    }
  }
  .preview-print-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .ant-row {
      display: flex;
      .ant-col {
        padding: 0 10px 20px 10px;
      }
    }
  }
}

</style>
